export default __webpack_public_path__ + "static/media/dinersclub.3ff8dbd0.svg";